import React from 'react'

export default function FormGroupPreview({
  label = '',
  value,
  children,
  addClass = '',
  icon = null,
  isNotes = false,
}) {
  return (
    <div className={`form-group ${addClass}`}>
      {!!label && <label>{label}</label>}
      {isNotes ? (
        <pre style={icon ? { display: 'inline-block' } : {}}>{value}</pre>
      ) : (
        <p style={icon ? { display: 'inline-block' } : {}}>{value}</p>
      )}
      {icon && <img src={icon} alt='' className='electic-icon' />}
      {children}
    </div>
  )
}
